import { FunctionComponent, PropsWithChildren } from 'react';
import { FormWrapperBox } from '../styles';

const FormWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <FormWrapperBox>{children}</FormWrapperBox>
);

export default FormWrapper;
